import React,{useState,useEffect,useRef} from 'react'
import {slider as createSlider} from 'displacer'
import displacementTextureSource from 'displacer/src/docs/assets/7.jpg'

function SlideDescription({onHeight,item:{description,link,title},active=false}){
  const elementRef = useRef();
  const callbackRef = useRef(onHeight);

  useEffect(()=>{
    callbackRef.current = onHeight;
  },[onHeight]);

  useEffect(
    ()=>{
      const onResize=()=>{
        const {current:callback} = callbackRef;
        callback&&callback(`${elementRef.current.getBoundingClientRect().height}px`);
      }
      window.addEventListener('resize',onResize);
      onResize();
      return ()=>{
        window.removeEventListener('resize',onResize);
      }
    },
    []
  );

  return (
    <div ref={elementRef} className={`slide-description ${active?'in':''}`}>
      {title && (<div dangerouslySetInnerHTML={{__html:title}} />)}
      {description && (<div dangerouslySetInnerHTML={{__html:description}} />)}
      {link && (<a style={{marginBottom:'1rem'}} href={link}>Mehr erfahren</a>)}
    </div>
  )
}

function useHeights(){
  const heightsRef = useRef({});
  const [heightKey,setHeightKey] = useState(0);

  return [heightsRef,heightKey,setHeightKey];
}

export default function CanvasSlider({title,items=[]}){
  const sliderRef = useRef();
  const canvasRef = useRef();
  const [index,setIndex] = useState(0);
  const [transitioning,setTransitioning] = useState(false);
  const [heightsRef,heightKey,setHeightKey] = useHeights();

  useEffect(()=>{
    const slider = createSlider({
      canvas:canvasRef.current,
      interval:10000,
      duration:1000,
      displacement:{
        intensity:.1,
        angle1:Math.PI / 4,
        angle2:-(Math.PI / 4) * 3
      },
      ease: t=>t<.5 ? 16*t*t*t*t*t : 1+16*(--t)*t*t*t*t ,
      displacementTextureSource,
      items:items.map(({src})=>src),
      onTransition:(newIndex)=>{
        setIndex(newIndex)
        setTransitioning(true)
      },
      onTransitionEnd:newIndex => {
        setIndex(newIndex);
        setTransitioning(false);
      }
    });

    sliderRef.current = slider;

    return ()=>{
      sliderRef.current.destroy();
    }
  },[]);

  if(!items.length) return null;

  return (
    <div className="columns is-v-centered">
      <div className="column is-4 is-offset-1 slide-descriptions-column">
        {title && (<div dangerouslySetInnerHTML={{__html:title}} />)}
        <div style={{'--index':index,'--length':items.length,'--height':heightsRef.current[`item${index}`]}} className="slide-descriptions">
          {items.map((item,key)=>(
            <SlideDescription
              onHeight={height => {
                setHeightKey(heightKey+1);
                heightsRef.current[`item${key}`] = height;
              }}
              item={item}
              key={key}
              active={key === index}
              />
            ))}
        </div>

        <div className="controls-wrap">
          <div className={`controls ${transitioning?'disabled':''}`}>
            <button onClick={()=>{!transitioning&&sliderRef.current.previous()}}>{'←'}</button>
            {index+1}{' / '}{items.length}
            <button onClick={()=>{!transitioning&&sliderRef.current.next()}}>{'→'}</button>
          </div>
        </div>

      </div>
      <div className="column slides-column is-5 is-offset-1">
        <a className="slides" href={items[index].link || 'javascript:void'}>
          <canvas ref={canvasRef} />
        </a>
      </div>
    </div>
  );
}